module.exports = __webpack_public_path__ + "static/media/good-kid-maad-city.61ee631e.jpg";